import { en } from './en';

const resources = {
  en,
};

export default resources;
